import i18n from '@/plugins/vue-i18n';
import { RouteRecordRaw } from 'vue-router';
import { Actions, Subjects } from '@boqnet/permissions';

const { t } = i18n.global;

const boqAdminRoutes = [
  {
    path: '/:organisationId?/boq-admin/vendors',
    name: 'boq-admin-vendors',
    component: () => import('@/views/boq-admin/Vendors.vue'),
    meta: {
      title: t('routes.vendors.vendorsPageTitle'),
      layout: 'boqAdmin',
      requiresAuth: true,
      // Context: LIST:BOQVendor is the vendor-catalogue read that every ordering role holds, so
      // guarding this platform-admin page on it admits a site field user. MANAGE is held only by
      // the platform catalogue roles, BOQ_ADMIN and BOQ_CAT_ADMIN (ORG_ADMIN gets SYNC, and so do
      // three site and project roles), which makes it the discriminator this page needs. ORG_ADMIN losing the
      // page is ratified, not a side effect — syncing does not require the admin view (PLE-1239).
      action: Actions.MANAGE,
      subject: Subjects.BOQ_VENDOR,
    },
  },
  {
    path: '/:organisationId?/boq-admin/vendors/create',
    name: 'create-boq-vendor',
    component: () => import('@/views/boq-admin/CreateVendor.vue'),
    meta: {
      title: t('routes.vendors.createBOQVendor'),
      layout: 'boqAdmin',
      requiresAuth: true,
      action: Actions.CREATE,
      subject: Subjects.BOQ_VENDOR,
    },
  },
  {
    path: '/:organisationId?/boq-admin/vendors/:id/:source/items',
    name: 'boq-admin-vendor-items',
    component: () => import('@/views/vendors/VendorItems.vue'),
    meta: {
      title: t('routes.vendors.vendorItemsPageTitle'),
      layout: 'boqAdmin',
      requiresAuth: true,
      action: Actions.LIST,
      subject: Subjects.BOQ_VENDOR_ITEM,
    },
  },
  {
    path: '/:organisationId?/boq-admin/vendors/:id/:name/:source/add-item',
    name: 'boq-admin-add-vendor-item',
    component: () => import('@/views/vendors/AddVendorItem.vue'),
    meta: {
      title: t('routes.vendors.addVendorItem'),
      layout: 'boqAdmin',
      requiresAuth: true,
      action: Actions.CREATE,
      subject: Subjects.BOQ_VENDOR_ITEM,
    },
  },
] as RouteRecordRaw[];

/** Every BOQ database page, so the side nav can show them as part of Vendors. */
export const BOQ_DATABASE_ROUTE_NAMES = boqAdminRoutes.map((route) => route.name as string);

export default boqAdminRoutes;
